<template>
  <div class="box5"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box5 {
  width: 100%;
  height: 300px;
  background: url("../../../assets/coursePage/cPuls/box5.png") no-repeat;
  background-size: cover;
}
</style>
